import { z } from "zod";
import { FornecedorDropDown } from "../../../../../common/domain/models/fornecedor_dropdown";
import { FuncionarioDropDown } from "../../../../../common/domain/models/funcionario_dropdown";

/**
 * MapaConcretagemSchema
 */

export const MapaConcretagemSchema = z.object({
  dataConcretagem: z.coerce.date({ required_error: 'Este campo deve ser preenchido!' }),
  tipoConcreto: z.string().nullable().default(null),
  slupFlowSolicitado: z.string().nullable().default(null),
  resistMpa: z.string().nullable().default(null),
  ensaioConcreto: z.coerce.number().nullable().default(null),
  fornecedor: z.string().or(z.custom<FornecedorDropDown>()).nullable().default(null).nullable().default(null),
  nroCarro: z.string().nullable().default(null),
  nroNotaFiscal: z.string().nullable().default(null),
  saidaUsina: z.string().nullable().default(null),
  entradaObra: z.string().nullable().default(null),
  inicioLancamento: z.string().nullable().default(null),
  finalLancamento: z.string().nullable().default(null),
  qteM3: z.string().nullable().default(null),
  slumpFlowEncontrado: z.string().nullable().default(null),
  localLancamento: z.string({ required_error: 'Este campo deve ser preenchido!' }),
  dataEnvioObra: z.coerce.date().nullable().default(null),
  laboratorio: z.string().or(z.custom<FornecedorDropDown>()).nullable().default(null).nullable().default(null),
  nroCorpoProva: z.string().nullable().default(null),
  nroLote: z.string().nullable().default(null),
  instrucaoLancamento: z.string().nullable().default(null),
  enviadoLaboratorio: z.coerce.number().nullable().default(null),
  dataEnviadoLaboratorio: z.coerce.date().nullable().default(null),
  resistencia12hs: z.string().nullable().default(null),
  resistencia12hs_checkbox: z.coerce.boolean().nullable().default(null),
  resistencia4: z.string().nullable().default(null),
  resistencia4_checkbox: z.coerce.boolean().nullable().default(null),
  resistencia7: z.string().nullable().default(null),
  resistencia7_checkbox: z.coerce.boolean().nullable().default(null),
  resistencia14: z.string().nullable().default(null),
  resistencia14_checkbox: z.coerce.boolean().nullable().default(null),
  resistencia21: z.string().nullable().default(null),
  resistencia21_checkbox: z.coerce.boolean().nullable().default(null),
  resistencia28: z.string().nullable().default(null),
  resistencia28_checkbox: z.coerce.boolean().nullable().default(null),
  resistencia56: z.string().nullable().default(null),
  resistencia56_checkbox: z.coerce.boolean().nullable().default(null),
  resistencia63: z.string().nullable().default(null),
  resistencia63_checkbox: z.coerce.boolean().nullable().default(null),
  idade1: z.string().nullable().default(null),
  resultado1: z.string().nullable().default(null),
  idade2: z.string().nullable().default(null),
  resultado2: z.string().nullable().default(null),
  idade3: z.string().nullable().default(null),
  resultado3: z.string().nullable().default(null),
  aprovado: z.coerce.number().nullable().default(null),
  dataAprovacao: z.coerce.date().nullable().default(null),
  responsavelAprovacao: z.string().or(z.custom<FuncionarioDropDown>()).nullable().default(null).nullable().default(null),
  observacao: z.string().nullable().default(null),
  arquivo1: z.instanceof(File).nullable().default(null),
  limparArquivo1: z.boolean().default(false),
  arquivo2: z.instanceof(File).nullable().default(null),
  limparArquivo2: z.boolean().default(false),
  arquivo3: z.instanceof(File).nullable().default(null),
  limparArquivo3: z.boolean().default(false),
  arquivo4: z.instanceof(File).nullable().default(null),
  limparArquivo4: z.boolean().default(false),
  moduloResistenciaGPA: z.string().nullable().default(null),
  ensaioModuloElasticidade: z.coerce.number().nullable().default(null),
  nroLaudo: z.string().nullable().default(null),
  checkElasticidade28: z.coerce.boolean().nullable().default(null),
  elasticidade28: z.string().nullable().default(null),
});

/**
 * MapaConcretagemForm
 */

export type MapaConcretagemForm = z.infer<typeof MapaConcretagemSchema>;